<template>
	<view class="details">
		<view class="details_head">
			<view class="details_head_a">合计消费：</view>
			<view class="details_head_b">
				<text class="details_head_b_a">¥{{ (info.amount / 100).toFixed(2) }}</text>
				<text class="details_head_b_b" v-if="info.haveDisCount === 1">骑行卡抵扣：¥{{Number((info.disCountMoney / 100).toFixed(2))}}</text>
			</view>
			<view class="details_head_c">
				<text>结算车型：{{ info.bikeType ? info.bikeType : '-' }}</text>
				<text>计费时长：{{ String(info.duration) ? info.duration : '-' }}分钟</text>
			</view>
		</view>
		<view class="details_list">
			<view class="details_list_item" v-for="(item, index) in info.memberRidesResponseList" :key="index">
				<view class="details_list_item_a">
					<text>{{ item.bikeType }}</text>
					<text>编号：{{ item.bikeCode }}</text>
				</view>
				<view class="details_list_item_b" v-if="item.rideStartTime.substring(5, 10) === item.rideEndTime.substring(5, 10)">
					骑行时间：{{ item.rideStartTime.substring(5, 10) }} {{ item.rideStartTime.substring(11, 16) }} ~ {{ item.rideEndTime.substring(11, 16) }} | {{ item.rideTime }}分钟
				</view>
				<view class="details_list_item_b" v-else>
					骑行时间：{{ item.rideStartTime.substring(5, 10) }} {{ item.rideStartTime.substring(11, 16) }} ~ {{ item.rideEndTime.substring(5, 10) }} {{ item.rideEndTime.substring(11, 16) }} | {{ item.rideTime }}分钟
				</view>
				<view class="details_list_item_b">
					计费时长：{{ item.duration }}分钟
				</view>
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				info: {}
			};
		},
		onLoad(option) {
			this.getInfo(option.id)
		},
		methods: {
			getInfo(goodsOrderId) {
				this.$u.api.ridesDetail({ goodsOrderId })
					.then(res => {
						if (res.code === 200) {
							console.log(res)
							this.info = res.data
						}
					})
			}
		}
	}
</script>

<style>
	page {
		background: #F7F7F7;
	}
</style>
<style lang="scss" scoped>
.details {
	width: 100%;
	.details_head {
		width: 100%;
		height: 216rpx;
		padding: 30rpx;
		box-sizing: border-box;
		background: #01B6AD;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		.details_head_a {
			font-size: 26rpx;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #FFFFFF;
		}
		.details_head_b {
			width: 100%;
			display: flex;
			align-items: center;
			.details_head_b_a {
				font-size: 40rpx;
				font-weight: 400;
				color: #FFFFFF;
			}
			.details_head_b_b {
				font-weight: 400;
				font-size: 26rpx;
				color: #FFFFFF;
				margin-left: 16rpx;
			}
		}
		.details_head_c {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: space-between;
			text {
				font-size: 26rpx;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #FFFFFF;
			}
		}
	}
	.details_list {
		width: 100%;
		padding: 20rpx;
		box-sizing: border-box;
		.details_list_item {
			width: 100%;
			padding: 24rpx 30rpx;
			box-sizing: border-box;
			background: #FFFFFF;
			border-radius: 20rpx;
			margin-bottom: 20rpx;
			&:last-child {
				margin: 0;
			}
			.details_list_item_a {
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: space-between;
				text {
					&:first-child {
						font-size: 32rpx;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #222222;
					}
					&:last-child {
						font-size: 26rpx;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #666666;
					}
				}
			}
			.details_list_item_b {
				width: 100%;
				margin-top: 16rpx;
				font-size: 28rpx;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #666666;
			}
		}
	}
}
</style>
